// ConfirmModal.jsx — modal de confirmación reutilizable
// Uso: <ConfirmModal title="¿Eliminar?" message="..." onConfirm={fn} onCancel={fn} danger />

export default function ConfirmModal({ title, message, onConfirm, onCancel, danger = true, confirmLabel = "Eliminar", cancelLabel = "Cancelar" }) {
  return (
    <div className="admin-modal-overlay" onClick={onCancel}>
      <div
        className="admin-modal"
        style={{ maxWidth: 420, textAlign: "center", padding: "2rem 1.8rem" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Ícono */}
        <div style={{
          width: 52, height: 52, borderRadius: "50%", margin: "0 auto 1.2rem",
          background: danger ? "#fdecea" : "var(--teal-light)",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: "1.4rem",
        }}>
          {danger ? "🗑️" : "⚠️"}
        </div>

        {/* Título */}
        <h2 style={{
          fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "1.05rem",
          color: "var(--charcoal)", marginBottom: ".6rem",
        }}>
          {title}
        </h2>

        {/* Mensaje */}
        {message && (
          <p style={{
            fontFamily: "var(--font-body)", fontSize: "0.85rem",
            color: "var(--text-muted)", lineHeight: 1.6, marginBottom: "1.6rem",
          }}>
            {message}
          </p>
        )}

        {/* Botones */}
        <div style={{ display: "flex", gap: ".8rem", justifyContent: "center" }}>
          <button
            onClick={onCancel}
            className="btn-outline"
            style={{ flex: 1, maxWidth: 160, padding: "8px 0", fontSize: "0.82rem" }}
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={danger ? "btn-danger" : "btn-primary"}
            style={{ flex: 1, maxWidth: 160, padding: "8px 0", fontSize: "0.82rem" }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
